import axios from 'axios';

/**
 * Fetch languages
 * 
 * @return {Promise}
 */
export const FetchLanguages = () => axios.get('mobile/languages');